// extracted by mini-css-extract-plugin
module.exports = {"image":"error_image__XqfVs"};